/**
 * Created by shaun on 16/09/2017.
 */

import Vue from 'vue';

import {EMPTY, ERROR, LOADING, READY, UPDATING, WORKFLOW_STATE_ONGOING} from 'module/constants';
import common from 'module/common';
import PortalError from 'module/error/PortalError';
import Moment from "moment/moment";
import filters from "module/filters";

const SET_SELECTED_STATE = 'selectedState';
const SET_SELECTED_QUOTE = 'selectedQuote';
const SET_SELECTED_PLOT = 'selectedQuotePlot';
const SET_SELECTED_QUOTE_FIELD = 'setSelectedQuoteField';
const SET_FILES = 'setFiles';
const SET_PLOTS_WITH_INVALID_RAW_ESTIMATE = 'setPlotsWithInvalidRawEstimate';

const CLEAR_ACTION_STATES = 'clearActions';
const SET_ACTION_STATE = 'actionState';
const UPDATE_SAVING_STATE = 'savingState';
const UPDATE_LAST_SAVED = 'lastSaved';
const TOGGLE_GLOBAL_SELECTION = 'toggleGlobalSelection';

const SOCKET_SET_VIEWING = 'SOCKET_setViewing';

// initial state
const state = {
  togglingGlobalSelection: null,
  selected: {
    state: EMPTY,
    stateByAction: {},
    quote: null,
    plot: null,
    viewing: []
  },
  saving: {},
  availableNoteTags: ['Important', 'Estimator','Feedback'],
  lastSaved: {
    quote: null,
    quoteAs: {
      search: null
    }
  },
  files: null,
  plotsWithInvalidRawEstimate: []
};

//actions
const actions = {
  select({commit, dispatch, rootGetters}, quote) {
    return new Promise((resolve, reject) => {
      if (quote._refresh === true) {
        commit(SET_SELECTED_STATE, UPDATING);
      } else {
        commit(CLEAR_ACTION_STATES);
        commit(SET_SELECTED_STATE, LOADING);
      }

      let companyId = quote['computed.companyId'] || _.get(quote, 'company.id', null);

      if (companyId !== null) {
        //We know company so lets load it
        dispatch('company/select', {_id: companyId}, {root: true});
      }

      common
        .httpPost('quote')
        .data({
          action: 'get',
          quoteId: quote._id,
          ref: quote.ref,
          idToken: rootGetters['user/idToken'](),
          routeVersion: 2.1
        })
        .then((res) => {
          if (quote._searchStore) {
            // res.data._searchStore = quote._searchStore;
          }

          //Select brand for project
          dispatch('brand/selectBrand', res.data.quote.brand.name, {root: true});

          dispatch('selectQuoteUsingProject', res.data.quote);

          if (state.selected.plot) {
            //Load update the selected plot
            dispatch('selectPlot', state.selected.plot);
          }

          resolve(res.data.quote);
        }, (error) => {
          console.log('Error', error);
          dispatch('error/error', error, {root: true});
          commit(SET_SELECTED_STATE, ERROR);
          reject();
        });
    });
  },
  selectQuoteUsingProject({commit}, quote) {
    commit(SET_SELECTED_STATE, READY);
    commit(SET_SELECTED_QUOTE, quote);
  },
  selectPlot({commit, state}, plotToSelect) {
    if (state.selected.state !== READY) {
      //Quote not loaded so select supplied plot
      commit(SET_SELECTED_PLOT, plotToSelect);
    } else {
      let availablePlots = _.get(state.selected.quote, 'plots.byPlot', []);

      let plot = availablePlots.filter(plot => plot.id === plotToSelect.id)[0] || null;

      commit(SET_SELECTED_PLOT, plot);
    }
  },
  refresh({state, dispatch}) {
    if (state.selected.state === READY && state.selected.quote !== null) {
      dispatch('select', {
        _id: state.selected.quote._id,
        _refresh: true
      });
    }
  },
  socketConnected(state, payload) {
  },
  setSelectedQuoteField({commit}, {path, value}) {
    path = 'selected.quote.' + path;
    commit(SET_SELECTED_QUOTE_FIELD, {path, value})
  },
  clearSelectedQuote({commit, dispatch}) {
    commit(SET_SELECTED_QUOTE, null)
  },
  multipleActions({commit, dispatch}, {quote, actions, data}) {
    return dispatch('save', {
      quote,
      label: 'Save Project',
      actions,
      refreshCompany: false,
      data
    });
  },
  copyProject({commit, dispatch}, {quote, company}) {
    dispatch('save', {
      quote,
      label: 'Copy Project',
      action: 'copyProject',
      refreshCompany: false,
      data: {
        company
      }
    }).then((res) => {
      dispatch('company/selectUsingCompanyObject', res.company, {root: true});
      dispatch('selectQuoteUsingProject', res.quote)
    }, (error) => {
      console.log('error', error);
    });
  },
  moveProject({commit, dispatch}, {quote, company}) {
    dispatch('save', {
      quote,
      label: 'Move Quote',
      action: 'moveProject',
      refreshCompany: false,
      data: {
        company
      }
    }).then((res) => {
      dispatch('company/selectUsingCompanyObject', res.company, {root: true});
      dispatch('selectQuoteUsingProject', res.quote)
    }, (error) => {
      console.log('error', error);
    });
  },
  setWorkflowState({commit, dispatch}, {quote, workflow, state, stateReason}) {
    dispatch('save', {
      quote,
      label: 'Status',
      action: 'setWorkflowState',
      data: {
        workflow,
        state,
        stateReason: stateReason
      }
    })
  },
  notifySlack({commit, dispatch}, {quote, channel, title, fields}) {
    dispatch('save', {
      quote,
      label: 'Notify Slack',
      action: 'notifySlack',
      data: {
        channel,
        title,
        fields
      }
    });
  },
  addProjectAddressVariation({commit, dispatch}, {quote, variationType, variationValue}) {
    dispatch('save', {
      quote,
      label: 'Add Address Variation',
      route: 'form.addProjectAddressVariation',
      data: {
        variationType,
        variationValue
      }
    });
  },
  removeProjectAddressVariation({commit, dispatch}, {quote, variationType, variationValue}) {
    dispatch('save', {
      quote,
      label: 'Remove Address Variation',
      route: 'form.removeProjectAddressVariation',
      data: {
        variationType,
        variationValue
      }
    });
  },

  requestSapAssessment({commit, dispatch}, quote){
    dispatch('save', {
      quote,
      label: 'Request a SAP Assessment',
      action: 'requestSapAssessment',
    })
  },

  addPotentialCustomerOrderNumber({commit, dispatch}, {quote, customerOrderNumber}) {
    dispatch('save', {
      quote,
      label: 'Add Customer Order Number',
      route: 'plots.addPotentialCustomerOrderNumber',
      data: {
        customerOrderNumber
      }
    });
  },
  removePotentialCustomerOrderNumber({commit, dispatch}, {quote, customerOrderNumber}) {
    dispatch('save', {
      quote,
      label: 'Remove Customer Order Number',
      route: 'plots.removePotentialCustomerOrderNumber',
      data: {
        customerOrderNumber
      }
    });
  },
  addContact({commit, dispatch}, {quote, contact}) {
    dispatch('save', {
      quote,
      label: 'Add Contact',
      route: 'contact.addContact',
      data: {
        contact
      }
    });
  },
  removeContact({commit, dispatch}, {quote, contact}) {
    dispatch('save', {
      quote,
      label: 'Remove Contact',
      route: 'contact.removeContact',
      data: {
        contact
      }
    });
  },
  addLinkedAccount({commit, dispatch}, {quote, account}) {
    dispatch('save', {
      quote,
      label: 'Add Linked Account',
      route: 'accounts.addLinkedAccount',
      data: {
        account
      }
    });
  },
  removeLinkedAccount({commit, dispatch}, {quote, account}) {
    dispatch('save', {
      quote,
      label: 'Remove Linked Account',
      route: 'accounts.removeLinkedAccount',
      data: {
        account
      }
    });
  },
  setAccountForService({commit, dispatch}, {quote, account}) {
    dispatch('save', {
      quote,
      label: 'Account For Service',
      route: 'accounts.setAccountForService',
      data: {
        account
      }
    });
  },
  setAccountForQuote({commit, dispatch}, {quote, account}) {
    dispatch('save', {
      quote,
      label: 'Account For Quote',
      route: 'accounts.setAccountForQuote',
      data: {
        account
      }
    });
  },
  addWorkSectionWorkflow({commit, dispatch}, {quote, plotId, workSection, workflow}) {
    dispatch('save', {
      quote,
      label: 'Add Workflow to Work Section',
      action: 'addWorkSectionWorkflow',
      data: {
        plotId,
        workSection,
        workflow
      }
    });
  },
  assignTo({commit, dispatch}, {quote, workflow, workflowId, user, step, plotId, workSection}) {
    dispatch('save', {
      quote,
      label: 'Assign Quote',
      action: 'assignTo',
      data: {
        workflow,
        workflowId,
        user,
        step,
        plotId,
        workSection
      }
    });
  },
  startStep({commit, dispatch}, {quote, workflow, workflowId, plotId, workSection}) {
    dispatch('save', {
      quote,
      label: 'Start Step',
      action: 'startStep',
      data: {
        workflow,
        workflowId,
        plotId,
        workSection
      }
    });
  },
  advanceWorkflowToStep({commit, dispatch}, {quote, workflowId, step}) {
    dispatch('save', {
      quote,
      label: 'Complete Step',
      action: 'advanceWorkflowToStep',
      data: {
        workflowId,
        step,
      }
    });
  },
  completeStep({commit, dispatch}, {quote, workflow, workflowId, currentStep, plotId, workSection}) {
    dispatch('save', {
      quote,
      label: 'Complete Step',
      action: 'completeStep',
      data: {
        workflow,
        workflowId,
        currentStep,
        plotId,
        workSection
      }
    });
  },
  goBackToStep({commit, dispatch}, {quote, workflow, workflowId, step, plotId, workSection}) {
    dispatch('save', {
      quote,
      label: 'Go Back to a Step',
      action: 'goBackToStep',
      data: {
        workflow,
        workflowId,
        step,
        plotId,
        workSection
      }
    });
  },
  setStepDueDate({commit, dispatch}, {quote, workflow, workflowId, step, dueDate, plotId, workSection}) {
    dispatch('save', {
      quote,
      label: 'Step Due Date',
      action: 'setStepDueDate',
      data: {
        workflow,
        workflowId,
        step,
        dueDate,
        plotId,
        workSection
      }
    });
  },
  clickToCall({commit, dispatch}, {quote, person, telephone}) {
    dispatch('save', {
      quote,
      label: 'Click To Call',
      route: 'quote.clickToCall',
      data: {
        person,
        telephone
      }
    });
  },
  sendEmail({commit, dispatch}, {quote, emailType, email}) {
    dispatch('save', {
      quote,
      label: 'Send Email',
      action: 'sendEmail',
      data: {
        emailType,
        email,
      }
    });
  },
  sendSms({commit, dispatch}, {quote, type, message}) {
    dispatch('save', {
      quote,
      label: 'Send SMS',
      action: 'sendSms',
      data: {
        type,
        message
      }
    });
  },
  updateForm({commit, dispatch}, {quote, form, contacts}) {
    dispatch('save', {
      quote,
      label: 'Save Form',
      action: 'updateForm',
      data: {
        contacts,
        form,
      }
    });
  },
  updateContacts({commit, dispatch}, {quote, contacts, additionalContacts}) {
    dispatch('save', {
      quote,
      label: 'Update Contacts',
      action: 'updateContacts',
      data: {
        contacts,
        additionalContacts,
      }
    });
  },
  addNote({commit, dispatch}, {selected, note, tags, recipients}) {
    return dispatch('save', {
      quote: selected,
      label: 'Add Note',
      action: 'addNote',
      data: {
        note,
        tags,
        recipients
      }
    });
  },
  setNotAsDealtWith({commit, dispatch}, {selected, noteId}) {
    dispatch('save', {
      quote: selected,
      label: 'Add Note',
      route: 'activity.setNoteAsDealtWith',
      data: {
        noteId,
      }
    });
  },
  addPurchaseOrder({commit, dispatch}, {quote, invoiceNo, purchaseOrderNo, purchaseOrderFile}) {
    dispatch('save', {
      quote,
      label: 'Mark Invoice as Paid',
      action: 'setInvoiceAsPaid',
      data: {
        invoiceNo,
        purchaseOrderNo,
        files: {
          purchaseOrderFile: purchaseOrderFile
        }
      }
    });
  },
  setInvoiceAsPaid({commit, dispatch}, {quote, invoiceNo, purchaseOrderNo}) {
    dispatch('save', {
      quote,
      label: 'Mark Invoice as Paid',
      action: 'setInvoiceAsPaid',
      data: {
        invoiceNo,
        purchaseOrderNo
      }
    });
  },
  addNewInvoice({commit, dispatch}, {quote}) {
    dispatch('save', {
      quote,
      label: 'Add New Invoice',
      route: 'invoice.addNewInvoice',
      data: {}
    });
  },
  updateServices({commit, dispatch}, {quote, services}) {
    dispatch('save', {
      quote,
      label: 'Update Service',
      action: 'serviceUpdate',
      data: {
        services,
      }
    });
  },
  sendPriceToBuilder({commit, dispatch}, {quote}) {
    dispatch('save', {
      quote,
      label: 'Send Price To Builder',
      route: 'activity.sendPriceToBuilder',
    });
  },
  overrideProvider({commit, dispatch}, {quote, service, provider}) {
    dispatch('save', {
      quote,
      label: 'Override Service Provider',
      route: 'service.overrideProvider',
      data: {
        service,
        provider
      }
    });
  },
  jobDetails({commit, dispatch}, {quote, jobDetails}) {
    let projectStartDate = new Moment(jobDetails.projectStartDate);

    if (projectStartDate.isValid()) {
      // if (projectStartDate.isValid() && projectStartDate > new Moment()) { NOT NEEDED FOR READ VALUES
      dispatch('projectStatus', {
        quote,
        startDate: projectStartDate.format()
      });
    }
  },
  updatePlot({commit, dispatch}, {quote, plot, plotMultiplier}) {
    dispatch('save', {
      quote,
      label: 'Update Plot',
      route: 'plots.updatePlot',
      data: {
        plotId: plot.id,
        newPlotName: plot.name,
        multiplier: plotMultiplier
      }
    })
  },
  addPlot({commit, dispatch}, {quote, plotName, multiplier}) {
    dispatch('save', {
      quote,
      label: 'Add Plot',
      route: 'plots.addPlot',
      data: {
        plotName: plotName,
        multiplier: multiplier
      }
    })
  },
  projectStatus({commit, dispatch}, {quote, startDate, state, stateReason}) {
    dispatch('save', {
      quote,
      label: 'Update Project Status',
      action: 'projectStatus',
      data: {
        startDate,
        state,
        stateReason
      }
    });
  },
  tenderDate({commit, dispatch}, {quote, tenderDate}) {
    dispatch('save', {
      quote,
      label: 'Update Project Tender Date',
      route: 'quote.updateProjectTenderDate',
      data: {
        tenderDate
      }
    });
  },
  dueDate({commit, dispatch}, {quote, workflow, dueDate, daysTilDue}) {
    dispatch('save', {
      quote,
      label: 'Update Due Date',
      action: 'dueDate',
      data: {
        workflow,
        dueDate,
        daysTilDue
      }
    });
  },
  addWatcher({commit, dispatch}, {quote, watcher}) {
    dispatch('save', {
      quote,
      label: 'Add Watcher',
      action: 'addWatcher',
      data: watcher
    });
  },
  removeWatcher({commit, dispatch}, {quote, watcher}) {
    dispatch('save', {
      quote,
      label: 'Remove Watcher',
      action: 'removeWatcher',
      data: watcher
    });
  },
  addAmendment({commit, dispatch}, {quote, reason, plotId, workflowName}) {
    dispatch('save', {
      quote,
      label: 'Add Amendment',
      route: 'quote.addAmendmentToWorkflow',
      data: {
        workflowName,
        reason,
        plotId,
      }
    });
  },
  addReGenerateProjectData({commit, dispatch}, {quote, workflowName}) {
    dispatch('save', {
      quote,
      label: 'Add Re-Generate Project Data',
      route: 'quote.addReGenerateProjectData',
      data: {
        workflowName
      }
    });
  },
  raisePurchaseOrder({commit, dispatch}, {quote}) {
    dispatch('save', {
      quote,
      label: 'Raise Purchase Order',
      route: 'quote.quantityTakeOffAddRaisePurchaseOrderStep',
    });
  },
  moveClientReports({commit, dispatch}, {quote}) {
    dispatch('save', {
      quote,
      label: 'Move Client Reports',
      route: 'quote.moveClientReports',
    });
  },
  regenerateReportsForPlots({commit, dispatch}, {quote, plots, priceType}) {
    dispatch('save', {
      quote,
      data: {
        plotsToRegenerate: plots,
        priceType: priceType
      },
      label: 'Regenerate Reports For Plots',
      action: 'regenerateReportsForPlots',
    });
  },
  regenerateNheFile({commit, dispatch}, {quote, key, value}) {
    return dispatch('save', {
      quote,
      label: 'Regenerate Nhe File',
      action: 'regenerateNheFile',
      data: {
        key,
        value,
      }
    });
  },
  wipNumber({commit, dispatch}, {quote, wipNumber}) {
    return dispatch('save', {
      quote,
      label: 'WIP Number',
      route: 'plots.wipNumber',
      data: {
        wipNumber
      }
    });
  },
  customerReadyToOrder({commit, dispatch}, {quote, basket, user}) {
    dispatch('save', {
      quote,
      label: 'Notify Branch You Are Ready To Order',
      action: 'customerReadyToOrder',
      data: {
        user,
        basket
      }
    });
  },
  setProjectIsBeingRepriced({commit, dispatch}, {quote, value}) {
    return dispatch('tempSet', {
      quote,
      key: 'projectBeingRepriced',
      value: true
    })
  },
  tempSet({commit, dispatch}, {quote, key, value}) {
    return dispatch('save', {
      quote,
      label: 'Temp Set',
      action: 'tempSet',
      data: {
        key,
        value,
      }
    });
  },
  reScanOrders({commit, dispatch}, {quote}) {
    return dispatch('save', {
      quote,
      label: 'Re Scan Order',
      route: 'quote.reScanOrders',
      data: {}
    });
  },
  addOrder({commit, dispatch}, {quote, iconIdentifier, internalIdentifier}) {
    return dispatch('save', {
      quote,
      label: 'Add Order',
      route: 'plots.loadAndAddOrder',
      data: {
        iconIdentifier,
        internalIdentifier
      }
    });
  },
  confirmOrder({commit, dispatch}, {quote, orderId}) {
    return dispatch('save', {
      quote,
      label: 'Confirm Order',
      route: 'plots.confirmOrder',
      data: {
        orderId
      }
    });
  },
  unconfirmOrder({commit, dispatch}, {quote, orderId}) {
    return dispatch('save', {
      quote,
      label: 'Unconfirm Order',
      route: 'plots.unconfirmOrder',
      data: {
        orderId
      }
    });
  },
  removeOrder({commit, dispatch}, {quote, orderId}) {
    return dispatch('save', {
      quote,
      label: 'Remove Order',
      route: 'plots.removeOrder',
      data: {
        orderId
      }
    });
  },
  copyPlot({commit, dispatch}, {quote, plot}) {
    return dispatch('save', {
      quote,
      label: "Copy Plot",
      route: "plots.copyPlot",
      data: {
        plot
      }
    });
  },
  deletePlots({commit, dispatch}, {quote, plots}) {
    //Action
    return dispatch('save', {
      quote,
      label: "Delete Plots",
      route: "plots.deletePlots",
      data: {
        plotIds: plots
      }
    });
  },
  setPlotName({commit, dispatch}, {quote, plot, name}) {
    return dispatch('save', {
      quote,
      label: "Set Plot Name",
      route: "plots.setPlotName",
      data: {
        plotId: plot,
        name
      }
    });
  },
  setPlotStartDate({commit, dispatch}, {quote, plot, date}) {
    return dispatch('save', {
      quote,
      label: "Set Plot Start Date",
      route: "plots.setPlotStartDate",
      data: {
        plot,
        date
      }
    });
  },
  setSelectedPlansForExecutivePack({commit, dispatch}, {quote, plans}) {
    return dispatch('save', {
      quote,
      label: "Set Selected Plans For Executive Packs",
      route: "drive.setSelectedPlansForExecutivePack",
      data: {
        plans
      }
    });
  },
  resetCache({commit, dispatch}, {quote}) {
    return dispatch('save', {
      quote,
      label: "Reset Cache",
      route: "quote.clearFileCache"
    })
  },
  refreshPlansFolder({commit, dispatch}, quote) {
    dispatch('save', {
      quote,
      label: 'Refresh Plans Folder',
      action: 'refreshPlansFolder',
    });
  },
  refreshFiles({commit, dispatch}, {quote}) {
    return dispatch('save', {
      quote,
      label: "Refresh Files",
      route: "drive.refreshFiles"
    })
  },
  setWorkSectionState({commit, dispatch}, {quote, plotId, workSectionName, state}) {
    return dispatch('save', {
      quote,
      label: "Set Work Section State",
      action: "setWorkSectionState",
      data: {
        plotId,
        workSectionName,
        state
      }
    });
  },
  saveMaterials({commit, dispatch}, {quote, plotId, workSectionName, materials}) {
    return dispatch('save', {
      quote,
      label: "Save Materials for " + workSectionName,
      action: "saveMaterials",
      data: {
        plotId,
        workSectionName,
        materials
      }
    });
  },
  updateWorkSectionStartDate({commit, dispatch}, {quote, plot, workSection, date}) {
    return dispatch('save', {
      quote,
      label: "Update Work Section Start Date",
      route: "plots.updateWorkSectionStartDate",
      data: {
        plot,
        workSection,
        date
      }
    });
  },
  updateWorkSectionDuration({commit, dispatch}, {quote, plot, workSection, duration}) {
    return dispatch('save', {
      quote,
      label: "Update Work Section End Date",
      route: "plots.updateWorkSectionDuration",
      data: {
        plot,
        workSection,
        duration
      }
    });
  },
  updateWorkSectionEndDate({commit, dispatch}, {quote, plot, workSection, date}) {
    return dispatch('save', {
      quote,
      label: "Set Work Section End Date",
      route: "plots.updateWorkSectionEndDate",
      data: {
        plot,
        workSection,
        date
      }
    });
  },
  rePriceFromPriceType({commit, dispatch}, {quote, priceType, plotId, overrideCustom}) {
    return dispatch('save', {
      quote,
      label: "Reprice Product",
      route: "plots.rePriceMaterials",
      data: {
        priceType,
        plotId,
        overrideCustom,
        searchOnly: true
      }
    });
  },
  savePCEProgress({commit, dispatch, rootGetters}, {quoteId, plotId, pceProgress}) {
    return new Promise((resolve, reject) => {
      common
        .httpPost('quote')
        .recaptchaAction('savePCEProgress')
        .data({
          idToken: rootGetters['user/idToken'](),
          action: 'savePCEProgress',
          quoteId: quoteId,
          pceProgress: pceProgress,
          plotId: plotId
        })
        .then((res) => {
          resolve(res.data);
        }, () => {
          reject();
        })
    });
  },
  addEditMaterial({state, commit, dispatch}, {
    quote,
    plotId,
    workSectionName,
    productCode,
    priceType,
    price,
    quantity,
    mode,
    oldProductCode
  }) {
    return dispatch('save', {
      quote,
      label: "Add/Update Material In Work Section",
      action: "addEditMaterial",
      data: {
        plotId,
        workSectionName,
        productCode,
        priceType,
        price,
        quantity,
        mode,
        oldProductCode
      }
    });
  },
  getProjectFiles({state, dispatch, commit, rootGetters}, {quote}) {
    return new Promise((resolve, reject) => {
      common
          .httpPost('quote')
          .data({
            idToken: rootGetters['user/idToken'](),
            action: 'getProjectFiles',
            quoteId: quote._id,
            quoteRef: quote.ref
          })
          .then((res) => {
            commit(SET_FILES, res.data.files);
          }, () => {
            reject();
          })
    });
  },
  getPlotsWithInvalidRawEstimate({state, dispatch, commit, rootGetters}, quote) {
    return new Promise((resolve, reject) => {
      common
          .httpPost('quote')
          .data({
            idToken: rootGetters['user/idToken'](),
            action: 'getPlotsWithInvalidRawEstimate',
            quoteId: quote._id,
            quoteRef: quote.ref
          })
          .then((res) => {
            commit(SET_PLOTS_WITH_INVALID_RAW_ESTIMATE, res.data.plotsWithInvalidRawEstimate);
            resolve();
          }, () => {
            reject();
          })
    });
  },
  createIconQuoteForInvoice({dispatch}, {quote, invoice}) {
    return dispatch('save', {
      quote,
      label: "Add Icon Quote For Invoice",
      route: "invoice.createIconQuote",
      data: {
        invoice: invoice
      }
    });
  },
  addInvoiceToSalesSheet({dispatch}, {quote, invoice, force}) {
    return dispatch('save', {
      quote,
      label: "Add Invoice To Sales Sheet",
      route: "invoice.addToSalesSheet",
      data: {
        invoice: invoice,
        force: force === true
      }
    });
  },
  voidInvoice({dispatch}, {quote, invoice}) {
    return dispatch('save', {
      quote,
      label: "Void Invoice",
      route: "invoice.voidInvoice",
      data: {
        invoice: invoice
      }
    });
  },
  addQuote({state, commit, dispatch}, {
    quote,
    plotName,
    materials,
    account,
    branch,
    dateRequired,
    customerOrderNumber,
    source
  }) {
    return dispatch('save', {
      quote,
      label: "Add Icon Quote For Project",
      action: "addQuote",
      data: {
        materials,
        account,
        branch,
        dateRequired,
        customerOrderNumber,
        plotName,
        source,
        searchOnly: true
      }
    });
  },
  requestExternalQuote({state, commit, dispatch}, {quote, category, suppliers}) {
    return dispatch('save', {
      quote,
      label: "External Quote",
      route: "externalQuotes.requestExternalQuote",
      data: {
        category,
        suppliers
      }
    });
  },
  resendExternalQuoteRequest({state, commit, dispatch}, {quote, category, supplier}) {
    return dispatch('save', {
      quote,
      label: "External Quote",
      route: "externalQuotes.resendExternalQuoteRequest",
      data: {
        category,
        supplier
      }
    });
  },
  uploadExternalQuotes({state, commit, dispatch}, {quote, quoteType, supplier, externalQuotes}) {
    return dispatch('save', {
      quote,
      label: "Upload External Quotes",
      action: "uploadExternalQuotes",
      data: {
        quoteType,
        supplier,
        files: {
          externalQuotes
        }
      }
    });
  },
  updateExternalQuoteState({state, commit, dispatch}, {quote, category, token, newState, reason}) {
    return dispatch('save', {
      quote,
      label: "Update External Quote State",
      route: "externalQuotes.updateExternalQuoteStateFromToken",
      data: {
        category,
        token,
        newState,
        reason
      }
    });
  },
  updateExternalQuoteCost({state, commit, dispatch}, {quote, quoteType, supplier, cost}) {
    return dispatch('save', {
      quote,
      label: "Update External Quote Cost",
      route: "externalQuotes.updateExternalQuoteCost",
      data: {
        quoteType,
        supplier,
        cost
      }
    });
  },
  updateIconQuoteState({state, commit, dispatch}, {quote, iconQuoteId, newQuoteState, searchOnly = false}) {
    return dispatch('save', {
      quote,
      label: "Update Icon Quote State For Project",
      route: "plots.updateIconQuoteState",
      data: {
        iconQuoteId,
        state: newQuoteState,
        searchOnly: searchOnly
      }
    });
  },
  addIconQuote({commit, dispatch}, {quote, iconIdentifier}) {
    return dispatch('save', {
      quote,
      label: 'Add Icon Quote',
      route: 'quote.upsertIconQuote',
      data: {
        iconIdentifier
      }
    });
  },
  save({commit, dispatch, state, rootState, rootGetters}, {
    quote,
    label,
    action,
    actions,
    route,
    data,
    refreshCompany
  }) {
    return new Promise((resolve, reject) => {

      dispatch('error/clear', null, {root: true});

      if (state.selected.state === UPDATING) {
        dispatch('error/error', new PortalError('Project Is Already Saving'), {root: true});
        reject();
      }

      data = _.merge({
        quoteId: filters.formatOID(quote._id),
        idToken: rootGetters['user/idToken'](),
        route,
        action,
        actions
      }, data);

      let savingActions = action ? [action] : actions;
      savingActions = savingActions || [];

      if (quote._searchStore) {
        data.view = rootState[quote._searchStore].view;
        data.search = rootState[quote._searchStore].search;
        data.filterValues = rootState[quote._searchStore].filters.selected;
        data.filterValues = _.isEmpty(data.filterValues) === false ? data.filterValues : null;
      }

      commit(SET_SELECTED_STATE, UPDATING);
      savingActions.forEach(action => commit(SET_ACTION_STATE, {action, newState: UPDATING}));

      savingActions.forEach(action => commit(UPDATE_SAVING_STATE, {quoteId: quote._id, action, newState: UPDATING}));

      common
        .httpPost('quote')
        .recaptchaAction(action)
        .data(data)
        .then((res) => {
          let data = res.data;

          savingActions.forEach(action => commit(UPDATE_SAVING_STATE, {quoteId: quote._id, action, newState: EMPTY}));

          commit(UPDATE_LAST_SAVED, data);

          if (quote._searchStore && data.quoteAs.search === null) {
            dispatch(quote._searchStore + '/removeRow', quote, {root: true});
          } else if (quote._searchStore) {
            dispatch(quote._searchStore + '/updateRow', {
              rowId: quote._searchStoreRowId || null,
              rowToUpdate: data.quoteAs.search
            }, {root: true});
          }

          if (refreshCompany !== false) {
            dispatch('company/refresh', null, {root: true});
          }

          if (rootState.view.searchStore.project) {
            //Reset current project search store as it could be outdated after save
            dispatch(rootState.view.searchStore.project.reset, null, {root: true});
          }

          if (state.selected.quote !== null && state.selected.quote._id && quote._id) {
            commit(SET_SELECTED_QUOTE, data.quote);
          }

          commit(SET_SELECTED_STATE, READY);
          savingActions.forEach(action => commit(SET_ACTION_STATE, {action, newState: READY}));

          resolve(data);
        }, (error) => {
          console.log('Error', data.label, data, error);
          dispatch('error/error', error, {root: true});
          savingActions.forEach(action => commit(UPDATE_SAVING_STATE, {quoteId: quote._id, action, newState: EMPTY}));
          if (state.selected.quote !== null && state.selected.quote._id && quote._id) {
            commit(SET_SELECTED_STATE, ERROR);
            savingActions.forEach(action => commit(SET_ACTION_STATE, {action, newState: ERROR}));
          }
          reject();
        });
    });
  }
};

//getters
const getters = {
  activeContacts(state) {
    let contacts = state.selected.quote !== null ? state.selected.quote.contacts
      .filter(contact => _.isString(contact))
      .map(contact => contact.toLowerCase()) : [];
    return _.get(state, 'selected.quote.company.contacts', []).filter((contact) => {
      let name = _.isString(contact.name) ? contact.name.toLowerCase() : null;
      return contacts.indexOf(name) >= 0;
    });
  },
  additionalContacts(state) {
    return state.selected?.quote?.additionalContacts ?? [];
  },
  selectedQuote(state) {
    return state.selected.quote;
  },
  isUpdating(state) {
    return state.selected.state === UPDATING;
  },
  isLoading(state) {
    return state.selected.state === LOADING;
  },
  isSaving: (state) => (quoteId, type) => {
    let key = [quoteId, type].join('_');
    return state.saving[key] && state.saving[key] === UPDATING;
  },
  savingState: (state) => (quoteId, type) => {
    let key = [quoteId, type].join('_');
    return state.saving[key] && state.saving[key] === UPDATING;
  },
  totalSaving(state) {
    return Object.keys(state.saving).length;
  },
  hasNheStep(state) {
    let remainingSteps = Object.values(_.get(state, 'selected.quote.workflow', {})).reduce((steps, workflow) => {
      if (_.get(workflow, 'state.state') === WORKFLOW_STATE_ONGOING) {
        return steps.concat([workflow.steps.current]).concat(workflow.steps.next);
      } else {
        return steps;
      }
    }, []);

    let nheSteps = ['estimatorReview', 'createEstimate', 'generateReports', 'confirmReports', 'amendQuote', 'reGenerateReports', 'confirmAmendedReports'];

    return remainingSteps.filter(step => nheSteps.indexOf(_.get(step, 'name', null)) >= 0).length >= 1;
  },
  getSelectedQuoteField: (state) => (path) => {
    path = 'selected.quote.' + path;
    let value = _.get(state, path);

    if (_.isObject(value) && value.$numberDecimal) {
      //convert mongo decimal object into number
      return value.$numberDecimal
    } else if (_.isObject(value) && value.$date) {
      //convert mongo date object into string
      return new Moment(value.$date.$numberLong, 'x').format('YYYY-MM-DD');
    } else {
      return value;
    }
  },
  togglingGlobalSelection(state) {
    return state.togglingGlobalSelection;
  }
};

// mutations
const mutations = {
  [SET_SELECTED_QUOTE_FIELD](state, {path, value}) {
    _.set(state, path, value);
  },
  [SET_SELECTED_STATE](state, newState) {
    state.selected.state = newState;
  },
  [SET_SELECTED_QUOTE](state, quote) {
    state.selected.quote = quote;
  },
  [SET_SELECTED_PLOT](state, plot) {
    state.selected.plot = plot;
  },
  [SET_FILES](state, files) {
    state.files = files;
  },
  [SET_PLOTS_WITH_INVALID_RAW_ESTIMATE](state, plotsWithInvalidRawEstimate) {
    state.plotsWithInvalidRawEstimate = plotsWithInvalidRawEstimate;
  },
  [CLEAR_ACTION_STATES](state) {
    state.selected.stateByAction = {};
  },
  [SET_ACTION_STATE](state, {action, newState}) {
    Vue.set(state.selected.stateByAction, action, newState);
  },
  [UPDATE_SAVING_STATE](state, {quoteId, action, newState},) {
    let key = [quoteId, action].join('_');

    if (newState !== READY && newState !== EMPTY) {
      Vue.set(state.saving, key, newState);
    } else if (state.saving[key]) {
      Vue.delete(state.saving, key);
    }
  },
  [UPDATE_LAST_SAVED](state, {quote, quoteAs}) {
    state.lastSaved.quote = quote;
    state.lastSaved.quoteAs = quoteAs;
  },
  [SOCKET_SET_VIEWING](state, {viewing}) {
    state.viewing = viewing;
  },
  [TOGGLE_GLOBAL_SELECTION](state, toggleState) {
    state.togglingGlobalSelection = toggleState;
  },
};

export default {
  state,
  actions,
  getters,
  mutations
}